/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'shopping-cart': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" d="M15.75 21.75a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0zm-6 2.25a2.25 2.25 0 110-4.5 2.25 2.25 0 010 4.5zM20.47 7.5l-2.078 6.75H9.35L7.218 7.5H20.47zM1.5 3h1.15l4.17 13.203a1.5 1.5 0 001.43 1.047H19.5a1.5 1.5 0 001.433-1.057l3-9.75A1.5 1.5 0 0022.5 4.5H6.27L5.18 1.047A1.5 1.5 0 003.75 0H1.5a1.5 1.5 0 000 3z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/dist/icons/shopping-cart.js